import { render, staticRenderFns } from "./ErrorInputMessage.vue?vue&type=template&id=124b7ffc&scoped=true&"
import script from "./ErrorInputMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorInputMessage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorInputMessage.vue?vue&type=style&index=0&id=124b7ffc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b7ffc",
  null
  
)

export default component.exports